// Thin wrapper over the Zendesk Help Center REST API with a tiny in-memory
// cache. `api` is the base resolved by faqConfig:
//   https://{host}/api/v2/help_center/{locale}
//
// All endpoints are public (no auth) and return JSON.

import axios from "axios";

const cache = {};

// GET `url` once and memoize the promise. Failed requests are evicted so a
// retry can re-issue the request.
function getJSON(url) {
  if (cache[url]) return cache[url];
  const p = axios
    .get(url, { headers: { Accept: "application/json" } })
    .then((res) => res.data)
    .catch((err) => {
      delete cache[url];
      throw err;
    });
  cache[url] = p;
  return p;
}

export function getSections(api, categoryId) {
  return getJSON(api + "/categories/" + categoryId + "/sections.json?per_page=100").then(
    (d) => d.sections || []
  );
}

export function getArticles(api, sectionId) {
  return getJSON(api + "/sections/" + sectionId + "/articles.json?per_page=100").then(
    (d) => d.articles || []
  );
}

// Full article (title + body + section_id) for the detail page.
export function getArticle(api, articleId) {
  return getJSON(api + "/articles/" + articleId + ".json").then(
    (d) => d.article || {}
  );
}

// Single section (used to resolve the section name for the detail page email).
export function getSection(api, sectionId) {
  return getJSON(api + "/sections/" + sectionId + ".json").then(
    (d) => d.section || {}
  );
}
